import { Select } from '@uag/react-core';
import { useTranslation } from 'react-i18next';

import {
    useGetInputBindingSlot,
    type BindingEditorProps
} from 'app/modules/wallforming/components/input-binding/hooks/useGetInputBindingSlot';
import { SlotActionIcon } from 'app/modules/wallforming/components/input-binding/SlotActionIcon';
import { InputModifier } from 'app/modules/wallforming/components/input-binding/types/inputModifier';
import { usePlacementStore } from 'app/modules/wallforming/components/state-management/placement';

const NONE = 'none';
const selectProps = { size: 'xs', comboboxProps: { zIndex: 20000 }, allowDeselect: false } as const;

/** Edits a standalone keyboard modifier without adding a pointer button or gesture. */
export const ModifierBindingEditor = ({ actionId, slot }: BindingEditorProps) => {
    const { t } = useTranslation();
    const { chord, isModified, isReadOnly } = useGetInputBindingSlot(actionId, slot);
    const { assignInputBinding, resetInputBindingSlot } = usePlacementStore.getState();
    const value = chord ?? NONE;
    const data = [
        { value: NONE, label: t('labelInputModifierNone') },
        ...Object.values(InputModifier).map((modifier) => ({ value: modifier, label: modifier }))
    ];

    return (
        <div className="flex min-w-0 items-center">
            <Select
                {...selectProps}
                className="custom-select modifier-select w-28 min-w-0"
                classNames={{ dropdown: 'modifier-dropdown' }}
                data={data}
                value={value}
                onChange={(modifier) => {
                    if (modifier) {
                        assignInputBinding(actionId, slot, modifier === NONE ? null : modifier);
                    }
                }}
            />
            <SlotActionIcon
                disabled={isReadOnly || !chord}
                icon="close"
                labelKey="labelKeyBindingClearSlot"
                onClick={() => assignInputBinding(actionId, slot, null)}
            />
            <SlotActionIcon
                disabled={isReadOnly || !isModified}
                icon="restart_alt"
                labelKey="labelKeyBindingResetSlot"
                onClick={() => resetInputBindingSlot(actionId, slot)}
            />
        </div>
    );
};
